(ns minorodata.components.data-views.sidebar
  (:require [clojure.string]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.components.infinite-scroll.core :as c.infinite-scroll]
            [minorodata.components.spinner.core :as c.spinner]
            [minorodata.data-views.model :refer [->data-views-page]]
            [re-posh.core :as re-posh]
            [reitit.frontend.easy :refer [href]]
            [ui.date-time :refer [date-tooltip]]
            [ui.tabs]
            [ui.typography :as typography]
            [ui.utils :refer [clsx]]))

(defn spinner-list-item []
  [:div {:class "m-3 flex justify-center"}
   [c.spinner/spinner-lucide {:size 32}]])


(defn fetch-more []
  (let [{:data-views-all/keys [page]} @(re-posh/subscribe [:data-views-all/pull '[:data-views-all/page]])]
    (dispatch [:data-views.api/fetch-all {:page (inc page)}])))

(defn fetch-more-shared []
  (let [{:data-views-shared/keys [page]} @(re-posh/subscribe [:data-views-shared/pull '[:data-views-shared/page]])]
    (dispatch [:data-views.api/fetch-shared {:page (inc page)}])))

(defn fetch-more-created []
  (let [{:data-views-created/keys [page]} @(re-posh/subscribe [:data-views-created/pull '[:data-views-created/page]])]
    (dispatch [:data-views.api/fetch-created {:page (inc page)}])))


(defn list-item [{:keys [data-view selected?]}]
  (let [{:data-view/keys [data-view-id name updated-by updated-at]} data-view]
    [:<>
     [:li
      [:a {:href     (href :data-view-details {:data-view-id data-view-id})
           :title    name
           :on-click #(dispatch [:data-views.events/switch])
           :data-cy  :data-view-sidebar-list-item
           :class    (clsx "flex flex-col gap-1 px-4 py-3 transition-colors hover:bg-kleene-neutral-04 border-b border-kleene-neutral-03"
                           "dark:hover:bg-kleene-dark-03 dark:border-kleene-dark-02"
                           {"bg-kleene-neutral-05 dark:bg-kleene-dark-01" selected?})}
       [typography/h4 {:class "truncate"}
        name]
       [typography/small
        [date-tooltip {:date updated-at}]
        [:span {:class "text-kleene-dark-05"} " by "]
        (:searchable-user/username updated-by)]]]]))

(defn items-list [props & children]
  (into [:ul props]
        children))

(defn data-views-list [{:keys [classes data-views loading? fetch-more-fn]}]
  (let [{:app-route/keys [params]} @(re-posh/subscribe [:app-route/pull])
        active-id (:data-view-id params)]
    (if (and (= (count data-views) 0)
             (not loading?))

      [:div {:class "p-2"}
       [typography/h3 "No data views"]]

      [:<>
       (into
        [c.infinite-scroll/main
         {:component       items-list
          :loader          [spinner-list-item]
          :loading?        loading?
          :on-scroll-end   fetch-more-fn}]
        (for [data-view data-views]
          (let [id (:db/id data-view)]
            ^{:key id}
            [list-item {:data-view data-view
                        :classes   classes
                        :selected? (= (:data-view/data-view-id data-view) active-id)}])))])))

(defn all-data-views [{:keys [classes]}]
  (let [_ (dispatch [:data-views.events/reset])]
    (fn []
      (let [data-views @(re-posh/subscribe [:data-views.subs/data-views-all])
            loading?   @(re-posh/subscribe [:mold-http/loading? :data-views.api/fetch-all])]
        [data-views-list {:data-views    data-views
                          :loading?      loading?
                          :classes       classes
                          :fetch-more-fn fetch-more}]))))

(defn shared-data-views [{:keys [classes]}]
  (let [_ (dispatch [:data-views.events/reset-shared])]
    (fn []
      (let [data-views @(re-posh/subscribe [:data-views.subs/data-views-shared])
            loading?   @(re-posh/subscribe [:mold-http/loading? :data-views.api/fetch-shared])]
        [data-views-list {:data-views    data-views
                          :loading?      loading?
                          :classes       classes
                          :fetch-more-fn fetch-more-shared}]))))

(defn created-data-views [{:keys [classes]}]
  (let [_ (dispatch [:data-views.events/reset-created])]
    (fn []
      (let [data-views @(re-posh/subscribe [:data-views.subs/data-views-created])
            loading?   @(re-posh/subscribe [:mold-http/loading? :data-views.api/fetch-created])]
        [data-views-list {:data-views    data-views
                          :loading?      loading?
                          :classes       classes
                          :fetch-more-fn fetch-more-created}]))))

(def tabs
  [{:key "all" :name "All"}
   {:key "shared" :name "Shared with me"}
   {:key "created" :name "Created by me"}])


(defn sidebar []
  (let [tab           @(re-posh/subscribe [:data-views-page/prop :data-views-page/sidebar-tab])
        on-tab-change #(dispatch [:data-views-page/update (->data-views-page {:sidebar-tab %})])]
    [ui.tabs/tabs-root {:default-value   (some-> tabs first (get :key))
                        :value           tab
                        :on-value-change on-tab-change
                        :class           "h-full overflow-hidden flex flex-col border-r"}
     [ui.tabs/tabs-list {:class      "flex px-2 pt-2 sticky top-0"
                         :variant    :underlined}
      (for [{:keys [key name]} tabs]
        ^{:key key}
        [ui.tabs/tabs-trigger {:value   key
                               :variant :underlined
                               :size    :small
                               :class "flex-auto"}
         name])]

     [:div {:class "shrink overflow-y-auto"}
      (for [t (mapv :key tabs)]
        ^{:key t}
        [ui.tabs/tabs-content {:value t}
         (case t
           "all"     [all-data-views]
           "shared"  [shared-data-views]
           "created" [created-data-views]
           nil)])]]))
